/* eslint-disable import/no-anonymous-default-export */
export default {
    colors: {

        primary: '#216FFF', // blue //  rgba(0, 112, 243, 1)
        secondary: '#f93eff', // lightblue // rgba(0, 185, 255, 1)
        accent: '#3DEFD4', // dark blue // rgba(13, 52, 89, 1)
        berry: '#ff003e', // rgba(255, 0, 62, 0.5) // Red
        berryLight: 'rgba(255, 0, 62, 0.5)', // Red // #ff003e
        green : '#00ff05', // green // rgba(0, 255, 5, 1)
        white: '#ffffff', // white // rgba(255, 255, 255, 1)
        dashboard_background: "rgba(21 19 22);", // dark blue // rgba(11, 11, 21, 1),
        black: '#000000', // black // rgba(0, 0, 0, 1),
        color_clear: 'rgba(6, 4, 10, 0.5)', // dark blue //
    },
    font: {
        family: {
            primary: '"Poppins", sans-serif',
            secondary: '"Play", sans-serif',
            berry: 'Russo One, sans-serif',
        },

        size: {
            small: '0.5rem',
            medium: '0.8rem',
            large: '0.9rem',
            xl: '1.2rem',
            xl_landing: '1.4rem',
            xxl: '1.6rem',
            heading: '1.8rem',
            logo: '3.5rem',
            hero: '3rem',
            hero_big: '8rem',
        },

        colors: {
            primary: '#ffdb11', // blue //  rgba(0, 112, 243, 1)
            secondary: '#00ff05', // green // rgba(0, 255, 5, 1)
            tertiary: 'black', 
        },

    },

    gradients: {
        primary: 'radial-gradient(circle,rgb(43 29 58 / 25%) 0%,rgb(45 45 53) 100%) rgb(90 84 84)',
        secondary: 'radial-gradient(circle,rgb(248 0 255 / 46%) 0%,rgb(62 62 64) 91%) rgb(65 62 63);'
    },

    margins: {
        small: '1rem',
        medium: '2rem',
        large: '3rem',
        xlarge: '4rem'
    },

    button: {
        colors: {
            primary: '#42c3cf', // light blue // rgba(66, 195, 207, 1)
            primary_clear: 'rgba(96, 3, 217, 0.5)', // light blue
        }
    },

    sizeWidth : {
        small: '80%',
        medium: '100%'
    },

    media: {
        small: 'max-width: 600px',
        phone: 'max-width: 900px',
        tablet: 'max-width: 1134px',
        xlarge: 'max-width: 1800px',
    }
}
